import { useState } from "react";
import clsx from "clsx";
import { NotepadTextIcon, PlusIcon } from "lucide-react";

import { JobNoteSheet } from "./JobNoteSheet";
import { JobNotesTable } from "./JobNotesTable";
import { Column, EmptyState } from "@/components";
import { Button } from "@/components/ui/button";

import { useGetJobNotes } from "@/hooks/queries/useGetJobNotes";

export const JobNotes = ({ className }: { className?: string }) => {
  const { data: jobNotes, status } = useGetJobNotes();
  const [isJobNoteSheetOpen, setIsJobNoteSheetOpen] = useState(false);

  if (status === "pending") {
    // TODO: Loading state.
    return null;
  } else if (status === "error") {
    // TODO: Error state.
    return null;
  }

  return (
    <Column className={clsx("items-end gap-6", className)}>
      {jobNotes.length > 0 ? (
        <>
          <Button
            className="rounded-full"
            onClick={() => {
              setIsJobNoteSheetOpen(true);
            }}
          >
            <PlusIcon className="h-4 w-4" />
            Create note
          </Button>
          <JobNotesTable className="w-full" jobNotes={jobNotes} />
        </>
      ) : (
        <EmptyState
          description="Notes added about this job will appear here."
          handlePrimaryClick={() => {
            setIsJobNoteSheetOpen(true);
          }}
          Icon={NotepadTextIcon}
          primaryButtonName="Create a note"
          primaryButtonVariant="default"
          title="Add your first note"
        />
      )}
      <JobNoteSheet
        jobNote={null}
        onOpenChange={setIsJobNoteSheetOpen}
        open={isJobNoteSheetOpen}
      />
    </Column>
  );
};
